import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Expenses from '../../../Components/pages/expenses/Expenses';
import classes from './ExpensesPage.module.scss';
import { getConstants } from '../../../actions/constFromApi';
import { getTandECountsContractor, getTandEPendingCounts } from '../../../actions/timesheet';

export default function ExpensesPage() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const constants = useSelector((state) => state.constFromApi);
  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);
  const exCounts = isApprover
    ? {
        /* TODO need BE to rework response for GET v1/get-tne-count the same as for GET v1/get-tne-count-contractor */
      }
    : useSelector((state) => state.timesheet.contractortandecounts?.Expense);
  const [key, setKey] = useState(1);

  useEffect(() => {
    if (searchParams.has('status') && !searchParams.has('page')) {
      setKey((prev) => prev + 1);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!constants.clients || !constants.worktypes) dispatch(getConstants(true));
    if (!exCounts) dispatch(isApprover ? getTandEPendingCounts() : getTandECountsContractor());
  }, [constants]);

  return <section className={`${classes.pageContainer}`}>{exCounts && <Expenses key={key} />}</section>;
}
